var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.14 33H25.86C30 33 31.65 30.465 31.845 27.375L32.625 14.985C32.835 11.745 30.255 9 27 9C26.085 9 25.245 8.475 24.825 7.665L23.745 5.49C23.055 4.125 21.255 3 19.725 3H16.29C14.745 3 12.945 4.125 12.255 5.49L11.175 7.665C10.755 8.475 9.91501 9 9.00001 9C5.74501 9 3.16501 11.745 3.37501 14.985L4.15501 27.375C4.33501 30.465 6.00001 33 10.14 33Z",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12H20.25",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27C20.685 27 22.875 24.81 22.875 22.125C22.875 19.44 20.685 17.25 18 17.25C15.315 17.25 13.125 19.44 13.125 22.125C13.125 24.81 15.315 27 18 27Z",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidCamera);
export default __webpack_public_path__ + "static/media/bfid-camera.3376be67e85a48cb23d68fbc367fa03d.svg";
export { ForwardRef as ReactComponent };